<template>
  <div class="p-error-page">
     <div
      v-html="$t('unauthorizedPage.title')"
      class="p-error-page--title"
    ></div>
    <div
      v-html="$t('unauthorizedPage.message')"
      class="p-error-page--message"
    ></div>
    <v-btn
      v-if="isAuthenticated"
      color="primary"
      class="p-btn-rounded mt-10"
      large
      rounded
      dark
      @click="logout"
    >
      {{ $t('logout') }}
    </v-btn>
  </div>
</template>


<script>
import store from '@/store'

import authMixin from '@/mixins/auth.mixin'


export default {
  mixins: [
    authMixin
  ],


  beforeRouteEnter (to, from, next) {
    const user = store.state.user.currentUser

    if (!user) {
      next()
    } else {
      next(from)
    }
  }
}
</script>
